import { IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const SectionTitle = styled("span")(() => ({
  color: colors.gray800,
  fontWeight: 600,
  fontSize: 22,
  fontFamily: "Manrope",
  lineHeight: "28px",
}));

export const UnlinkVolumeButton = styled(IconButton)(() => ({
  padding: "0px !important",
}));

const styles = makeStyles(() => ({
  label: {
    whiteSpace: "nowrap",
  },
  fieldsContainer: {
    margin: 0,
  },
  title: {
    padding: "12px 0",
    "&:not(:first-child)": {
      marginTop: 20,
    },
  },
  subTitle: {
    color: "#1D2939",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
  inventoryDesc: {
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },

  preApprovalTableContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    border: "1px solid #e4e7ec",
    borderRadius: 8,
    backgroundColor: "#F7F7F9",
    boxSizing: "border-box",
    marginBottom: 16,
  },
  preApprovalGridRow: {
    display: "grid",
    gridTemplateColumns:
      "minmax(56px, 0.95fr) minmax(96px, 2fr) minmax(44px, 0.7fr) minmax(44px, 0.7fr) minmax(80px, 1.1fr) minmax(56px, 0.9fr) minmax(56px, 0.9fr) 44px",
    columnGap: 4,
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  preApprovalTable: {
    width: "100%",
    minWidth: 0,
  },
  preApprovalHeadRow: {
    height: 32,
    backgroundColor: "#fcfcfd",
    boxShadow: "inset 0px -1.5px 0px #d2e2f0",
  },
  preApprovalHeadCell: {
    backgroundColor: "#fcfcfd",
    fontFamily: "Manrope",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 900,
    lineHeight: "16px",
    letterSpacing: "0em",
    textTransform: "uppercase",
    color: "rgb(29, 41, 57)",
    padding: "5px",
    paddingTop: 0,
    paddingBottom: 0,
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  preApprovalHeadCellAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
  },
  preApprovalBodyRowZebra: {
    backgroundColor: "#f2f4f7",
  },
  preApprovalBodyRowPlain: {
    backgroundColor: "#fff",
  },
  preApprovalBodyCell: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    fontFamily: "Manrope",
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0em",
    color: "#667085",
    padding: "4px 0px 4px 4px",
  },
  preApprovalBodyCellAction: {
    justifyContent: "center",
  },
  preApprovalCellControl: {
    width: "100%",
    minWidth: 0,
    "& > *": {
      width: "100%",
    },
  },
  preApprovalFooterRow: {
    borderTop: "1px solid #E4E7EC",
    backgroundColor: "#F7F7F9",
    textAlign: "left",
  },
}));

export default styles;
